import {
  GET_PREPARED_CARDS_PLANNING_SUCCESS,
  GET_ACTUAL_OCCURRENCE_SUCCESS,
  SET_PLANNING_IS_LOADING,
  GET_OCCURRENCES_SUCCESS,
  CLEAR_ACTUAL_OCCURRENCE,
  SELECT_PLANNING_VERSION,
  WAITING_SAVING,
} from "./constants"

// TEMPLATES
import {
  GET_TEMPLATES_STUDIO_BY_TYPE_SUCCESS,
  GET_TEMPLATES_BY_ID_CONTROL_SUCCESS,
  GET_TEMPLATES_BY_TYPE_SUCCESS,
  GET_TEMPLATES_BY_ID_SUCCESS,
  GET_TEMPLATES_SUCCESS,
  SET_LOADER_DATA,
} from "../Templates/constants"

// RESPONSES
import {
  GET_GLOBAL_RESPONSE_INFORMATION_BY_TEMPLATE_ID_SUCCESS,
  GET_GLOBAL_RESPONSE_INFORMATION_BY_RESPONSE_ID_SUCCESS,
  GET_RESPONSES_BY_TEMPALTE_ID_SUCCESS,
  GET_RESPONSE_BY_BUSINESS_SUCCESS,
  POST_FILES_FOR_RESPONSE_SUCCESS,
  GET_RESPONSE_BY_USER_SUCCESS,
  GET_RESPONSE_BY_ID_SUCCESS,
  RESET_ID_SAVE_RESPONSES,
  SAVE_RESPONSES_SUCCESS,
  GET_RESPONSES_SUCCESS,
} from "../Responses/constants"

// LIST CHOICE
import { GET_LIST_CHOICE_SUCCESS, GET_LIST_CHOICE_BY_ID_SUCCESS } from "../ListChoice/constants"

const initialState = {
  responsesListByTemplate: [],
  cardsPreparedPlanning: [],
  controlOccurrences: [],
  filesForResponse: [],
  responsesList: [],
  templatesList: [],
  choicesList: [],
  responsesGlobalInformation: {},
  choicesListSelect: {},
  actualOccurrence: {},
  template: {},
  response: {},
  planningVersionToUse: "",
  idResponseSave: "",
  loaderPlanning: true,
  loaderData: false,
  waitingSaving: false,
}

function formDataReducer(state = initialState, { type, payload }) {
  switch (type) {
    //**************************************************************************
    //**************************** REDUCER TEMPLATES ***************************
    //**************************************************************************
    case GET_TEMPLATES_SUCCESS:
      return {
        ...state,
        templatesList: payload,
      }
    case GET_TEMPLATES_BY_ID_SUCCESS:
    case GET_TEMPLATES_BY_ID_CONTROL_SUCCESS:
      return {
        ...state,
        template: payload,
      }
    case GET_TEMPLATES_BY_TYPE_SUCCESS:
    case GET_TEMPLATES_STUDIO_BY_TYPE_SUCCESS:
      return {
        ...state,
        templatesList: payload,
      }
    case SET_LOADER_DATA:
      return {
        ...state,
        loaderData: payload,
      }
    //**************************************************************************
    //************************* REDUCER RESPONSE *******************************
    //**************************************************************************
    case GET_RESPONSES_SUCCESS:
      return {
        ...state,
        responsesList: payload,
      }
    case GET_RESPONSE_BY_ID_SUCCESS:
      return {
        ...state,
        response: payload,
      }
    case GET_RESPONSES_BY_TEMPALTE_ID_SUCCESS:
      return {
        ...state,
        responsesListByTemplate: payload,
      }
    case GET_RESPONSE_BY_USER_SUCCESS:
    case GET_RESPONSE_BY_BUSINESS_SUCCESS:
      return {
        ...state,
        responsesList: payload,
      }
    case GET_GLOBAL_RESPONSE_INFORMATION_BY_TEMPLATE_ID_SUCCESS:
    case GET_GLOBAL_RESPONSE_INFORMATION_BY_RESPONSE_ID_SUCCESS:
      return {
        ...state,
        responsesGlobalInformation: payload,
      }
    case POST_FILES_FOR_RESPONSE_SUCCESS:
      return {
        ...state,
        filesForResponse: payload,
      }
    case SAVE_RESPONSES_SUCCESS:
      return {
        ...state,
        idResponseSave: payload?.newResponseId,
      }
    case RESET_ID_SAVE_RESPONSES:
      return {
        ...state,
        idResponseSave: "",
      }
    case WAITING_SAVING:
      return {
        ...state,
        waitingSaving: payload,
      }
    //**************************************************************************
    //********************** REDUCER LIST CHOICE *******************************
    //**************************************************************************
    case GET_LIST_CHOICE_SUCCESS:
      return {
        ...state,
        choicesList: payload,
      }
    case GET_LIST_CHOICE_BY_ID_SUCCESS:
      return {
        ...state,
        choicesListSelect: payload,
      }
    //**************************************************************************
    //********************** PLANNING VERSION **********************************
    //**************************************************************************
    case SELECT_PLANNING_VERSION:
      return { ...state, planningVersionToUse: payload }
    //**************************************************************************
    //******************************* CARDS PLANNING THEO **********************
    //**************************************************************************
    case GET_PREPARED_CARDS_PLANNING_SUCCESS:
      return { ...state, cardsPreparedPlanning: payload }
    case SET_PLANNING_IS_LOADING:
      return { ...state, loaderPlanning: payload }
    case GET_OCCURRENCES_SUCCESS:
      return { ...state, controlOccurrences: payload }
    case GET_ACTUAL_OCCURRENCE_SUCCESS:
      return { ...state, actualOccurrence: payload }
    case CLEAR_ACTUAL_OCCURRENCE:
      return { ...state, actualOccurrence: {} }
    default:
      return state
  }
}

export default formDataReducer
